<ng-template [ngIf]="!isPercentualeSoccombenza && request">
	<div class="col-sm-12 coldx" id="pannello10edie">
		<h4>{{title}}</h4>
		<div class="row container_fieldset">
			<fieldset class="form-group">
				<legend>Modalità di inserimento<em aria-hidden="true" style="color: red;">*</em></legend>
				<div radioButtonInput class="col-sm-12" style="padding-bottom: 20px;" [nameRadio]="'tipoInserimentoSelMod'"
					[radioButtonOptions]="tipoInserimento" [checkedRadioId]="tipoInserimentoSel.id" [mandatory]="true"
					[classCol]="'col-sm-6'" (onReturn)="tipoInserimentoSel = $event; changeInserimento($event)"
					[(ngModel)]="tipoInserimentoSel" [edit]="true" [mandatory]="true" [submitPending]="false"></div>
			</fieldset>
		</div>
		<div class="row" style="margin-top: 20px;">
			<div datePickerInput class="col-sm-4" [labelInput]="'Data inizio aggiornamento'" [mandatory]="true"
				[submitPending]="!inserimento" [(ngModel)]="request.dataRevisioneDa"></div>

			<div comboModInput class="col-sm-4" [labelInput]="'Grado di rischio'" [optionsCombo]="gradiRischioOptions"
				[objectReference]="request.gradoRischio" (onReturn)="request.gradoRischio = $event" [mandatory]="true"
				(change)="settaPercentualeSoccombenza($event.target.value)" [ngModel]="request.gradoRischio"></div>

			<div naturalNumberInput class="col-sm-4" [labelInput]="'% di soccombenza'" [maxLength]="'3'"
				[(ngModel)]="request.percentualeSoccombenza" [submitPending]="tipoInserimentoSel.id === 2"></div>

		</div>
		<div class="row">
			<div textInput class="col-sm-4" [labelInput]="'Motivo aggiornamento'" [(ngModel)]="request.motivoRevisione">
			</div>
		</div>
		<ng-template [ngIf]="tipoInserimentoSel.id === 2">
			<table class="table-striped table table-revisione-fondorischi" *ngIf="!request.importiTotali">
				<caption class="sr-only">Tabella importi totali</caption>
				<tr>
					<th>Parte</th>
					<!--<th style="width: 150px;">Società</th>-->
					<th>Importo</th>
					<th>Spese di giudizio</th>
					<th>Interessi legali</th>
					<!--<th>Rivalutazione</th>-->
					<!-- <th>Previdenziali</th>
				  <th>Assistenziali</th>
				  <th>Tfr</th> -->
					<th *ngIf="!request.ripartizioneEqua">Azioni</th>
				</tr>
				<!-- <ng-template [ngIf]="!request?.ripartizioneEqua"> -->
				<tr *ngFor="let fondorischioControparte of request?.fondorischiControparti; let i = index">
					<td>{{fondorischioControparte.controparte?.parte?.nominativo}}</td>
					<!--<td>{{fondorischioControparte.societa?.nome}}</td>-->
					<td>{{!fondorischioControparte.id && request.ripartizioneEqua ? calcolaSomma([cacolaRipartizione('sorte', fondorischioControparte), 0]) : fondorischioControparte.sorte | euro}} €</td>
					<td>{{!fondorischioControparte.id && request.ripartizioneEqua ? calcolaSomma([cacolaRipartizione('speseGiudizio', fondorischioControparte), 0]): fondorischioControparte.speseGiudizio | euro}} €</td>
					<td>{{!fondorischioControparte.id && request.ripartizioneEqua ? calcolaSomma([cacolaRipartizione('interessi', fondorischioControparte), 0]) : fondorischioControparte.interessi | euro}} €</td>
					<!--<td>{{approssimaImporto(fondorischioControparte.rivalutazione) | euro}} €</td>-->
					<!-- <td>{{approssimaImporto(fondorischioControparte.previdenziali) | euro}} €</td>
					<td>{{approssimaImporto(fondorischioControparte.assistenziali) | euro}} €</td>
					<td>{{approssimaImporto(fondorischioControparte.tfr) | euro}} €</td> -->
					<td style="width: 70px;" *ngIf="!request.ripartizioneEqua">
						<a id="link{{i}}" [ngClass]="isModifica && i === index ? 'link-grey' : ''" href="javascript:void(0);" (click)="index = i; modificaSingoloFondoRischio(fondorischioControparte)">
							<span class="glyphicon glyphicon-pencil"></span>
						</a>
						<a *ngIf="!isModifica" href="javascript:void(0);" (click)="eliminaFondoRischio(fondorischioControparte)">
							<span class="glyphicon glyphicon-trash"></span>
						</a>
						<a  *ngIf="isModifica" href="javascript:void(0);" style="color: grey; cursor: not-allowed; pointer-events: none">
							<span class="glyphicon glyphicon-trash"></span>
						</a>
					</td>
				</tr>
				<!-- </ng-template> -->
				<!-- <ng-template [ngIf]="!inserimento && request?.ripartizioneEqua">
				  <tr>
					<td></td>
					<td></td>
					<td>{{request?.fondorischiControparti[0].sorte * request?.fondorischiControparti.length | euro}} €</td>
					<td>{{request?.fondorischiControparti[0].speseGiudizio * request?.fondorischiControparti.length | euro}}€
					</td>
					<td>{{request?.fondorischiControparti[0].interessi * request?.fondorischiControparti.length | euro}} €</td>
					<td>{{request?.fondorischiControparti[0].rivalutazione * request?.fondorischiControparti.length | euro}}€
					</td>
					<td>{{request?.fondorischiControparti[0].previdenziali * request?.fondorischiControparti.length | euro}}€
					</td>
					<td>{{request?.fondorischiControparti[0].assistenziali * request?.fondorischiControparti.length | euro}}€
					</td>
					<td>{{request?.fondorischiControparti[0].tfr * request?.fondorischiControparti.length | euro}} €</td>
					<td>
					  <a *ngIf="inserimento" href="#" onclick="return false;"
						 (click)="openDeleteFondorischioControparte(request?.fondorischiControparti[0])">
						<span class="glyphicon glyphicon-trash"></span>
					  </a>
					</td>
				  </tr>
				</ng-template> -->
				<!-- <tr *ngIf="!request?.fondorischiControparti || request?.fondorischiControparti.length === 0">
				  <td colspan="11">Nessun controparte aggiunto</td>
				</tr> -->
			</table>
			<div class="row" *ngIf="request.ripartizioneEqua && request.fondorischiControparti.length > 0" style="padding-right: 15px;">
				<a href="javascript:void(0);"  [class]="isModifica ? 'disabledLink' : 'linkButtonDelete'"(click)="eliminaRipartizione()">Elimina
					ripartizione equa</a>
				<a href="javascript:void(0);" style="float: right; padding-right: 20px;"
					(click)="modificaRipartizioneEqua()" [class]="isModifica ? 'disabledLink' : 'linkButton'">Modifica ripartizione equa</a>
				<a *ngIf="requestReset.id && requestReset.ripartizioneEqua && request.fondorischiControparti[0].id" href="javascript:void(0);" style="float: right; padding-right: 20px;"
					(click)="request.ripartizioneEqua = false; filtraControparti()" [class]="isModifica ? 'disabledLink' : 'linkButton'">Modifica ripartizione parte</a>
			</div>

			<ng-template [ngIf]="petitumRevisioneForm">
				<form [formGroup]="petitumRevisioneForm" (ngSubmit)="aggiungi();"
					style="border: 1px solid #ccc; padding: 15px;">
					<div class="row">
						<!--<div comboModInput class="col-sm-4"
						 [labelInput]="'Societ&agrave;'" formControlName="societa"
						 [objectReference]="fondoRischioControparte.societa"
						 (onReturn)="fondoRischioControparte.societa = $event"
						 [labelOption]="'nome'"
						 [optionsCombo]="societaOptions" [ngModel]="fondoRischioControparte.societa"></div>-->
						<div comboModInput class="col-sm-4" [labelInput]="'Parte'" formControlName="controparte"
							[objectReference]="fondoRischioControparte.controparte"
							(onReturn)="fondoRischioControparte.controparte = $event; changeControparte()" [labelOption]="'parte.nominativo'"
							[mandatory]="!request.ripartizioneEqua && !request.importiTotali"
							[submitPending]="request.ripartizioneEqua && request.fondorischiControparti.length > 0"
							[optionsCombo]="controparti" [ngModel]="fondoRischioControparte.controparte"></div>
						<div singleCheckBoxModInput [labelInput]="'Ripartizione Equa'" [showLabel]="false"
							idInput="selected" [objectReference]="request?.ripartizioneEqua" class="col-sm-4"
							[submitPending]="request.fondorischiControparti.length > 0"
							(onReturn)="onChangeRipartizioneEqua($event);"></div>
						<div singleCheckBoxModInput [labelInput]="'Importi totali'" [showLabel]="false"
							idInput="importi_tot" [objectReference]="request.importiTotali" class="col-sm-4"
							[submitPending]="isModifica || request.fondorischiControparti.length > 0 "
							formControlName="importiTotali" (onReturn)="onChangeImportiTotali($event)"></div>
					</div>
					<div class="row" *ngIf="!request.importiTotali">
						<div textInputCurrency class="col-sm-4" [labelInput]="'Importo'" formControlName="sorte"
							[location]="'SezioneEconomica'" [control]="petitumRevisioneForm.controls['sorte']"
							[(ngModel)]="fondoRischioControparte.sorte"></div>
						<div textInputCurrency class="col-sm-4" [labelInput]="'Spese di Giudizio'"
							formControlName="speseGiudizio" [location]="'SezioneEconomica'"
							[control]="petitumRevisioneForm.controls['speseGiudizio']"
							[(ngModel)]="fondoRischioControparte.speseGiudizio"></div>
						<div textInputCurrency class="col-sm-4" [labelInput]="'Interessi legali'" formControlName="interessi"
							[location]="'SezioneEconomica'" [control]="petitumRevisioneForm.controls['interessi']"
							[(ngModel)]="fondoRischioControparte.interessi"></div>
						<!--<div textInputCurrency class="col-sm-3" [labelInput]="'Rivalutazione'"
							formControlName="rivalutazione" [location]="'SezioneEconomica'"
							[control]="petitumRevisioneForm.controls['rivalutazione']"
							[(ngModel)]="fondoRischioControparte.rivalutazione"></div>-->
						<!-- <div textInputCurrency class="col-sm-3"
						 [labelInput]="'Previdenziali'" formControlName="previdenziali"
						 [location]="'SezioneEconomica'"
						 [control]="petitumRevisioneForm.controls['Previdenziali']"
						 [(ngModel)]="fondoRischioControparte.previdenziali"></div>
					<div textInputCurrency class="col-sm-3"
						 [labelInput]="'Assistenziali'" formControlName="assistenziali"
						 [location]="'SezioneEconomica'"
						 [control]="petitumRevisioneForm.controls['assistenziali']"
						 [(ngModel)]="fondoRischioControparte.assistenziali"></div>
					<div textInputCurrency class="col-sm-3"
						 [labelInput]="'Tfr'" formControlName="tfr"
						 [location]="'SezioneEconomica'"
						 [control]="petitumRevisioneForm.controls['tfr']" [(ngModel)]="fondoRischioControparte.tfr"></div> -->

					</div>

					<div class="row" *ngIf="request.importiTotali">
						<div textInputCurrency class="col-sm-4" [labelInput]="'Importo'"
							formControlName="importoFR" [location]="'SezioneEconomica'"
							[control]="petitumRevisioneForm.controls['importoFR']"
							[(ngModel)]="request.importoFR"></div>
						<div textInputCurrency class="col-sm-4" [labelInput]="'Spese di Giudizio'"
							formControlName="speseFR" [location]="'SezioneEconomica'"
							[control]="petitumRevisioneForm.controls['speseFR']" [(ngModel)]="request.speseFR"></div>
						<div textInputCurrency class="col-sm-4" [labelInput]="'Interessi legali'"
							formControlName="interesseFR" [location]="'SezioneEconomica'"
							[control]="petitumRevisioneForm.controls['interesseFR']"
							[(ngModel)]="request.interesseFR">
						</div>
						<!--<div textInputCurrency class="col-sm-3" [labelInput]="'Rivalutazione'"
							formControlName="interessiSpeseLegali" [location]="'SezioneEconomica'"
							[control]="petitumRevisioneForm.controls['interessiSpeseLegali']"
							[(ngModel)]="request.interessiSpeseLegali"></div>-->
						<!-- <div textInputCurrency class="col-sm-3"
						 [labelInput]="'Previdenziali'" formControlName="previdenziali"
						 [location]="'SezioneEconomica'"
						 [control]="petitumRevisioneForm.controls['Previdenziali']"
						 [(ngModel)]="fondoRischioControparte.previdenziali"></div>
					<div textInputCurrency class="col-sm-3"
						 [labelInput]="'Assistenziali'" formControlName="assistenziali"
						 [location]="'SezioneEconomica'"
						 [control]="petitumRevisioneForm.controls['assistenziali']"
						 [(ngModel)]="fondoRischioControparte.assistenziali"></div>
					<div textInputCurrency class="col-sm-3"
						 [labelInput]="'Tfr'" formControlName="tfr"
						 [location]="'SezioneEconomica'"
						 [control]="petitumRevisioneForm.controls['tfr']" [(ngModel)]="fondoRischioControparte.tfr"></div> -->

					</div>

					<div class="row">
						<p class="mandatory col-sm-12">
							<em>* Campi obbligatori</em>
						</p>
					</div>

					<div class="row">
						<div *ngIf="!request.importiTotali" class="col-sm-3 col-xs-3 col-xs-offset-9 col-sm-offset-9">
							<p submitButton
								[disabled]="!petitumRevisioneForm.valid || (!fondoRischioControparte.controparte && !request.ripartizioneEqua) || (request.ripartizioneEqua && controparti.length === 0) || (request.ripartizioneEqua && request.fondorischiControparti.length>0 && !isModifica)"
								[labelButton]="isModifica ? 'Salva modifiche' : 'Aggiungi'"></p>
						</div>
					</div>
				</form>
			</ng-template>
		</ng-template>

		<div class="row" style="margin-top: 20px;">
			<div class="col-sm-3 col-xs-6">
				<p>
					<button type="button" class="btn btn-outline-secondary btn-block"
						(click)="resetForm()">Reset</button>
				</p>
			</div>
			<div class="col-sm-3 col-xs-6 col-sm-offset-6">
				<p>
					<button type="button"
						[disabled]="(tipoInserimentoSel.id === 1 && !request.percentualeSoccombenza) ||
						(tipoInserimentoSel.id === 2 && request.fondorischiControparti.length === 0 && !request.importiTotali) || isModifica || !request.gradoRischio"
						class="btn btn-primary btn-block" (click)="save();">Salva
					</button>
				</p>
			</div>
		</div>
	</div>
</ng-template>

<ng-template [ngIf]="isPercentualeSoccombenza">
	<div class="col-sm-12 coldx" id="pannello11">
		<h4>{{title}}</h4>
		<div class="row">
			<div textInputCurrency class="col-sm-6" [labelInput]="'Percentuale Soccombenza'"
				[location]="'SezioneEconomica'" [(ngModel)]="request.percentualeSoccombenza" [maxValueLimit]="100">
			</div>
		</div>
		<div class="row" style="margin-top: 20px;">
			<div class="col-sm-3 col-xs-3">
				<p>
					<button type="button" class="btn btn-outline-secondary btn-block"
						(click)="annulla();">Annulla</button>
				</p>
			</div>
			<div class="col-sm-3 col-xs-6 col-sm-offset-6">
				<p>
					<button type="button"
						[disabled]="!request.percentualeSoccombenza || request.percentualeSoccombenza > 100"
						class="btn btn-primary btn-block" (click)="save();">Salva
					</button>
				</p>
			</div>
		</div>
	</div>
</ng-template>







<!-- <div class="col-sm-12 coldx" >
<h4>{{title}}</h4>
<ng-template [ngIf]="petitumRevisioneForm">
<form [formGroup]="petitumRevisioneForm" (ngSubmit)="save();">
	<div class="row">		
		<div datePickerInput class="col-sm-3" [labelInput]="'Data inizio revisione'"  
			[mandatory]="true"	[submitPending]="!inserimento"
			formControlName="dataRevisioneDa" [(ngModel)]="request.dataRevisioneDa"></div>	
		
		<div comboModInput class="col-sm-3" [labelInput]="'Grado di rischio'"
			formControlName="gradoRischio"
			[optionsCombo] ="gradiRischioOptions"
			[objectReference]="request.gradoRischio"
			(onReturn)="request.gradoRischio = $event"
			(change)="settaPercentualeSoccombenza($event.target.value)"
			[ngModel]="request.gradoRischio"></div>
			
			<div naturalNumberInput class="col-sm-3" 
			[labelInput]="'% di soccombenza'" [maxLength]="'3'"
				formControlName="percentualeSoccombenza" [(ngModel)]="request.percentualeSoccombenza" ></div>

		<div textInput class="col-sm-3" [labelInput]="'Motivo revisione'" 
		formControlName="motivoRevisione" [(ngModel)]="request.motivoRevisione"></div>			
	</div>
	
	<div class="row">
		<p class="mandatory col-sm-12">
			<em>* Campi obbligatori</em>
		</p>
	</div>
	
	<div class="row">
		<div class="col-sm-3 col-xs-3">
			<p>
				<button type="button" class="btn btn-outline-secondary btn-block" (click)="createForm();">Reset</button>
			</p>
		</div>
		<div class="col-sm-3 col-xs-6 col-sm-offset-6">
			<p submitButton [disabled]="!petitumRevisioneForm.valid" [labelButton]="'Salva'"></p>
		</div>
	</div>
</form>
</ng-template>
</div> -->